import { render, staticRenderFns } from "./AiQuestionaryOnboarding.vue?vue&type=template&id=54d8ef14&"
import script from "./AiQuestionaryOnboarding.vue?vue&type=script&lang=ts&"
export * from "./AiQuestionaryOnboarding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports